import Flickity from 'flickity-imagesloaded';

export default class Gallery {
  constructor(root) {
    this.root = root;
    this.list = this.root.querySelector('.u-gallery__list');
    this.prevBtn = this.root.querySelector('.u-slider__pagination__prev');
    this.nextBtn = this.root.querySelector('.u-slider__pagination__next');

    this.bind();
  }

  bind() {
    const initialIndex = this.list.getAttribute('data-start-index') ?
      parseInt(this.list.getAttribute('data-start-index'), 10) :
      Math.floor(this.list.children.length / 2);

    this.flkty = new Flickity(this.list, {
      prevNextButtons: false,
      pageDots: false,
      // initialIndex: Math.floor(this.list.children.length / 2),
      initialIndex,
      wrapAround: true,
      imagesLoaded: true
    });

    this.goPrev = this.goPrev.bind(this);
    this.goNext = this.goNext.bind(this);

    this.prevBtn.addEventListener('click', this.goPrev);
    this.nextBtn.addEventListener('click', this.goNext);
  }

  goPrev(e) {
    e && e.preventDefault();
    this.flkty.previous();
  }

  goNext(e) {
    e && e.preventDefault();
    this.flkty.next();
  }

  destroy() {

  }
}
